<div class="question-container">
  <div class="question">
    <div class="number">{{index + 1}}.</div>
    <div class="text">{{questionResult.question.text}}</div>
  </div>
  <div class="answer" [ngSwitch]="questionResult.question.type.techId">

    <app-answered-options-result *ngSwitchCase="QUESTION_TYPES.SINGLE_ANSWER"
                                 [testId]="testId"
                                 [testResultId]="testResultId"
                                 [testType]="testType"
                                 [options]="questionResult.question.options"
                                 [answeredOptions]="questionResult.answeredOptions"
                                 [multiple]="false"></app-answered-options-result>

    <app-answered-options-result *ngSwitchCase="QUESTION_TYPES.MULTIPLE_ANSWER"
                                 [testId]="testId"
                                 [testResultId]="testResultId"
                                 [testType]="testType"
                                 [options]="questionResult.question.options"
                                 [answeredOptions]="questionResult.answeredOptions"
                                 [multiple]="true"></app-answered-options-result>

    <app-answered-text-result *ngSwitchCase="QUESTION_TYPES.TEXT_ANSWER"
                              [testId]="testId"
                              [testResultId]="testResultId"
                              [testType]="testType"
                              [answerText]="questionResult.question.answer"
                              [answeredText]="questionResult.answeredText"></app-answered-text-result>

  </div>
</div>
<div class="result-container">
  <app-question-result-check *ngIf="testType !== 'POLL'"
    [readonly]="readonly"
    [editMode]="questionResult.isCorrect === null"
    [testResultId]="testResultId"
    [questionResult]="questionResult"></app-question-result-check>
</div>
